// src/components/routes/Afirst/Afirst.js

import React from "react";
import { Routes, Route } from 'react-router-dom';
import Login from "../Sign/Login/Login";
import Logout from "../Sign/Logout/Logout";
import Register from "../Sign/Register/Register";
import Instance from "../Forms/Instance/Instance";
import Qrcode from "../Forms/Qrcode/Qrcode";
import Messenger from "../Forms/Messenger/Messenger";
import Subscription from "../Forms/Subscription/Subscription";
import ForgotPassword from "../Sign/ForgotPassword/ForgotPassword";
import ResetPassword from "../Sign/ResetPassword/ResetPassword";
import Reports from "../Forms/Reports/Reports";
import Responses from "../Forms/Response/Responses";

const Afirst = () => {
    return (
        <Routes>
            {/* Auth routes */}
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:id/:token" element={<ResetPassword />} />

            {/* Instance routes */}
            <Route path="/" element={<Instance />} />
            <Route path="/create-instance" element={<Instance />} />
            <Route path="/:email/generate" element={<Instance />} />

            {/* QR code routes */}
            <Route path="/:email/qrcode" element={<Qrcode />} />

            {/* Message routes */}
            <Route path="/:email/message" element={<Messenger />} />
            
            {/* Feature routes */}
            <Route path="/subscription" element={<Subscription />} />
            <Route path="/:email/subscription" element={<Subscription />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/:email/reports" element={<Reports />} />
            <Route path="/whatsapp-responses" element={<Responses />} />
            <Route path="/:instanceId/whatsapp-responses" element={<Responses />} />
        </Routes>
    );
};

export default Afirst;
